import React from "react";
import FieldError from "../field-error/FieldError";
import "./RadioStandalone.css";

interface RadioStandaloneProps {
  label: string;
  name: string;
  value: string | number;
  checked?: boolean;
  onChange: () => void;
  error?: string;
  disabled?: boolean;
}

const RadioStandalone: React.FC<RadioStandaloneProps> = ({
  label,
  name,
  value,
  checked = false,
  onChange,
  error,
  disabled = false,
}) => {
  return (
    <div className="radio-wrapper">
      <label className={`radio-label ${disabled ? "radio-disabled" : ""}`}>
        <input
          type="radio"
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="radio-input"
        />
        <span className="radio-custom" />
        <span className="radio-label-text">{label}</span>
      </label>

      {error && <FieldError>{error}</FieldError>}
    </div>
  );
};

export default RadioStandalone;
